import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3cbfe98c")
const _hoisted_1 = { class: "inner" }
const _hoisted_2 = { class: "items" }
const _hoisted_3 = { class: "item-name" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UnselectTagButton = _resolveComponent("UnselectTagButton")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown-wrapper", [_ctx.isOpen && 'is-open']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", {
          class: _normalizeClass([
            'item all-content',
            (!_ctx.selectedTags.length && !_ctx.selectedCategories.length) ? 'is-selected' : '',
          ]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetSelection && _ctx.resetSelection(...args)))
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("all_content")), 1)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
          return (_openBlock(), _createElementBlock("li", {
            key: category.id,
            class: _normalizeClass([
            'item',
            _ctx.selectedCategories.includes(category) ? 'is-selected' : '',
          ])
          }, [
            _createElementVNode("span", {
              class: "item-name",
              onClick: ($event: any) => (_ctx.toggleCategorySelect(category))
            }, _toDisplayString(category.title), 9, _hoisted_4)
          ], 2))
        }), 128)),
        _hoisted_5,
        _createVNode(_component_perfect_scrollbar, { options: { wheelPropagation: false } }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsData, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                class: _normalizeClass([
              'item',
              _ctx.selectedTags.includes(item) ? 'is-selected' : '',
              !_ctx.availableTags.includes(item.id) && 'is-disabled',
            ])
              }, [
                _createElementVNode("span", {
                  class: "item-name",
                  onClick: ($event: any) => (_ctx.toggleTagSelect(item))
                }, _toDisplayString(item.name), 9, _hoisted_6),
                _createVNode(_component_UnselectTagButton, {
                  onClick: ($event: any) => (_ctx.unselectTag(item))
                }, null, 8, ["onClick"])
              ], 2))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}